<button
  mat-icon-button
  [matMenuTriggerFor]="filtro"
  style="visibility: hidden; position: absolute; width: 0; height: 0"
  (menuClosed)="closeFilter()"
></button>

<mat-menu #filtro="matMenu">
  <div class="filter filtro" matMenuContent (click)="$event.stopPropagation()">
    <div class="filter__header filtro">
      <div class="filter__header-title filtro">Filtros</div>

      <button mat-button class="filter__header-button filtro" (click)="clearFilter()">
        Limpar filtros
      </button>
    </div>
    <mat-divider></mat-divider>

    <ng-template #container/>
  </div>
</mat-menu>
